import React from 'react';
import "./findfiretalent.scss"
import { useNavigate } from 'react-router-dom';

const FindHireTalent = () => {
    const navigate = useNavigate()
    return (

        <>
            <div className="find-hire-talent">
                <div className="find-hire-talent-container">

                    <div className="find-hire-talnet-flex2">
                        <img src="/image/AdBanner-recuiter.png" alt="" />
                        <div className="find-hire-talnet-flex1">
                            <h3>Find and hire top talents.</h3>
                            <h6>Post a job or project today!</h6>
                            <div className="find-hiretalents-button">
                                <button onClick={()=>navigate("/job-post")} >Post a Job</button>
                                <button onClick={()=>navigate("/project-post")}>Post a Project</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FindHireTalent
